"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "constants", {
  enumerable: true,
  get: function get() {
    return _values.constants;
  }
});
exports["default"] = void 0;
var _values = _interopRequireWildcard(require("./values"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var TAG_GIFT = _values.constants.TAG_GIFT,
  TYPE_GIFT = _values.constants.TYPE_GIFT,
  NO_VALUE_FOUND = _values.constants.NO_VALUE_FOUND;
var getValuesObject = function getValuesObject(category, subCategory, productType) {
  return {
    category: category || NO_VALUE_FOUND,
    subCategory: subCategory || NO_VALUE_FOUND,
    productType: productType || NO_VALUE_FOUND
  };
};
var getProductValues = function getProductValues(tags) {
  if (!tags) return getValuesObject();
  var match = _values["default"].find(function (entry) {
    var allTags = entry.tags.every(function (tag) {
      if (Array.isArray(tag)) return tag.some(function (variation) {
        return tags.includes(variation);
      });
      return tags.includes(tag);
    });
    var noExceptions = entry.exceptions.every(function (exception) {
      return !tags.includes(exception);
    });
    return allTags && noExceptions;
  });
  var productValues = match ? getValuesObject.apply(void 0, _toConsumableArray(match.values)) : getValuesObject();
  if (tags.includes(TAG_GIFT)) productValues.productType = TYPE_GIFT;
  return productValues;
};
var _default = exports["default"] = getProductValues;